module.exports = __webpack_public_path__ + "img/icon-history.33fee03c.svg";